import { IReleaseNote } from "../types"

export const RELEASE_1_4_11: IReleaseNote = {
    status: "PAST",
    title: "v1.4.11",
    date: "10th December 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "This patch includes replacing the account setup options 'Solo Installer' and 'Team Manager' with a unified 'Installer' option for new installer creating an account on the platform",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following changes have been been added:",
            bullets: [
                "The ability to sign up as a solo installer has been removed ",
                "We’ve improved the sign-up process for new installers joining the platform. The updated process automatically establishes the individual as the company’s admin, whether they’re a sole trader or part of a group. During registration, users will be prompted to provide their company details",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following changes have been been added:",
            bullets: [
                "New installers, whether joining as as a sole trader or as a group, will be required to enter their company details during the sign-up process",
                "You will be able to search for newly joining companies using the Company Search feature",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
